import { useLocation } from 'react-router-dom'
import { apiURL } from '../utilities/URLs'
import { customerData } from '../utilities/CustomerData'

export default function SyncNewDocuments({ isPage }) {
  const location = useLocation()
  const upload = location.state?.upload !== undefined ? location.state.upload : true
  const idMeURL = `${process.env.REACT_APP_IDME_API_DOMAIN}/oauth/authorize?client_id=${process.env.REACT_APP_IDME_CLIENT_ID}&redirect_uri=${apiURL}/idme&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2/verify/always${upload ? '&state=upload' : ''}`

  const handleStartIDme = () => {
    if(!customerData.impersonationMode)
      localStorage.setItem('idme', upload ? '2' : '0')
    
    window.location.href = idMeURL
  }

  return (
    isPage ? (
      <div className='w-full h-[80dvh] flex flex-col items-center justify-center'>
        <div className='max-w-lg max-sm:w-11/12 flex flex-col items-center justify-center shadow-lg rounded-md p-8 gap-4'>
          <p className='text-lg font-semibold text-center'>Upload New Documents</p>
          <p className='text-center'>Based on your ID.me data, we detected you have expired documents. In order to continue, please click the button below to upload new documents.</p>
          <div className='flex justify-center w-full'>
            <button onClick={handleStartIDme}>
              <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
            </button>
          </div>
          <p className='italic text-sm text-gray-400'>NOTE: We will be using ALL personal information (including address) for future use. Please make sure your IDme information is completely up to date and is <span className='font-bold'>YOUR INFORMATION</span> and not someone elses, like a spouse.</p>
        </div>
      </div>
    ) : (
      <div className='lg:w-full w-11/12 flex flex-col gap-4 mt-4'>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
          <div className='w-full flex flex-col items-center'>
            <div className='w-full flex flex-col items-center gap-8'>
            <button onClick={handleStartIDme}>
              <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
            </button>
            <p className='font-bold text-xl'>Based on your ID.me data, we detected you have expired documents. In order to continue, please click the button above to upload new documents.</p>
            </div>
          </div>
        </div>
      </div>
    )
  )
}